// 根据镜片宽度显示N，W，M
export function filterByLensWidth(width) {
  let text = '';
  switch (true) {
    case width <= 48:
      text = 'S';
      break;
    case width >= 49 && width <= 53:
      text = 'M';
      break;
    case width >= 54:
      text = 'L';
      break;
    default:
      break;
  }
  return text;
}
export function filterByLensTotalWidth(Temple) {
  let text = '';
  switch (true) {
    case Temple < 129:
      text = 'S';
      break;
    case Temple >= 129 && Temple <= 135:
      text = 'M';
      break;
    case Temple > 135:
      text = 'L';
      break;
    default:
      break;
  }
  return text;
}
